import clsx from 'clsx';

type BorderedSectionProps = {
  title?: string;
  children?: React.ReactNode;
  headingBorderBottom?: boolean;
  noPadding?: boolean;
  extendOptions?: JSX.Element | null;
  className?: string; // Custom class for the outer section
  headingClassName?: string; // Custom class for the heading
  contentClassName?: string; // Custom class for the content
};

const BorderedSection = ({
  title,
  children,
  headingBorderBottom = true,
  noPadding,
  extendOptions,
  className,
  headingClassName,
  contentClassName,
}: BorderedSectionProps) => {
  const sectionClasses = clsx(
    'w-full border border-borders rounded-[10px] overflow-hidden',
    className,
  );

  const headingContainerClasses = clsx(
    'text-primary-100 px-5 font-medium border-borders p-4 tracking-wider flex items-center justify-between text-base',
    headingBorderBottom && 'border-b',
    !title && 'h-14',
    headingClassName,
  );

  const contentClasses = clsx(
    'relative h-full',
    !noPadding && 'px-6 py-8',
    contentClassName,
  );

  return (
    <section className={sectionClasses}>
      {(title || extendOptions) && (
        <div className="bg-[#F8F8F8]">
          <div className={headingContainerClasses}>
            <div>{title}</div>
            <div className="py-3">{extendOptions}</div>
          </div>
        </div>
      )}
      <div className={contentClasses}>{children}</div>
    </section>
  );
};

export default BorderedSection;
